import { cloneDeep } from 'lodash'
import { ToastProgrammatic as Toast } from 'buefy'

const defaultState = {
  current: null,
  duplicatedGuardianships: []
}

export const state = () => cloneDeep(defaultState)

export const getters = {
  current(state) {
    return state.current
  },
  isFinished(state) {
    return (
      state.current?.status === 'completed' ||
      state.current?.status === 'canceled' ||
      state.current?.status === 'kinship_rejected'
    )
  },
  duplicatedGuardianships(state) {
    return state.duplicatedGuardianships
  }
}

export const mutations = {
  current(state, current) {
    state.current = current
  },
  duplicatedGuardianships(state, duplicatedGuardianships) {
    state.duplicatedGuardianships = duplicatedGuardianships
  }
}

export const actions = {
  async getById({ commit }, id) {
    const result = await this.$coreApi.$get(`staff/guardianships/${id}`)
    commit('current', result.data)
  },
  async cancel({ commit, state }, guardianshipId) {
    await this.$coreApi.$post('staff/guardianships/cancel', {
      guardianship_ids: [guardianshipId]
    })

    this.$router.push(this.app.localePath({ name: 'admin-guardianships' }))

    Toast.open({
      duration: 5000,
      message: this.$i18n.t('commons.removedNotification.guardianship'),
      position: 'is-top',
      type: 'is-success'
    })
  },
  async getDuplicateGuardianships({ commit }, id) {
    const result = await this.$coreApi.$get(`staff/guardianships/${id}/duplicated_guardianships`)
    commit('duplicatedGuardianships', result)
  },
  async batchCancel({ dispatch }, guardianshipIds) {
    try {
      await this.$coreApi.$post('staff/guardianships/cancel', {
        guardianship_ids: guardianshipIds
      })

      Toast.open({
        duration: 5000,
        message: this.$i18n.t('commons.removedNotification.guardianship'),
        position: 'is-top',
        type: 'is-success'
      })
    } catch (error) {
      Toast.open({
        duration: 5000,
        message: this.$i18n.t('commons.removedNotification.errorGuardianship'),
        position: 'is-top',
        type: 'is-danger'
      })
    }
  }
}
